module.exports = __webpack_public_path__ + "img/cash-minus.d0f7d572.svg";